<template>
  <div>
    <div class="container">
      <div class="jumbo">
        <div class="jumbo__title">Мы делаем веб-сервисы и приложения под ключ</div>
        <div class="jumbo__description">А еще производим оборудование и масштабируемое ПО, обеспечивая поддержку в режиме 24/7</div>
        <div class="mt-40 jumbo__actions">
          <a class="button button--lg" @click.prevent="showModal('5e60b459ad16fa004472f7c5')">Узнайте стоимость</a>
          <router-link class="jumbo__link" to="/contact">Оставьте заявку</router-link>
        </div>
        <span class="jumbo__helper">или просто листайте дальше</span>
      </div>
    </div>
    <div class="container container--fluid container--mobile-full">
      <Portfolio mode="sample" />
      <div class="text-center">
        <router-link to="/portfolio" class="button">Открыть портфолио</router-link>
      </div>
    </div>
    <WhatWeDo />
    <Stack />
    <Clients />
    <DarkModule />
    <VueFooter />
  </div>
</template>
<script>
const name = "Home"

import Portfolio from '@/components/Portfolio.vue'
import Stack from '@/components/Stack.vue'
import Feedback from '@/components/Feedback.vue'
import DarkModule from '@/components/DarkModule.vue'
import WhatWeDo from '@/components/WhatWeDo.vue'
import Clients from '@/components/Clients.vue'
import VueFooter from '@/components/VueFooter.vue'


export default {
  name,
  components: {
    Portfolio,
    Stack,
    Feedback,
    DarkModule,
    WhatWeDo,
    VueFooter,
    Clients
  }
}

</script>
